import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { ConfigSettingsService } from '@ebeihilfe/core';
import { TranslateModule } from '@ngx-translate/core';

import accountMenuItems, { AccountMenuItem } from './menu-account-items';

@Component({
  imports: [MatIcon, MatButtonModule, MatDivider, MatMenuModule, RouterLink, TranslateModule],
  standalone: true,
  selector: 'portal-toolbar-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMenuComponent implements OnInit {
  private readonly configService: ConfigSettingsService = inject(ConfigSettingsService);
  public accountMenuItems = signal<AccountMenuItem[]>([]);

  public ngOnInit(): void {
    this.accountMenuItems.set(
      accountMenuItems.filter((item) => {
        if (item.grantGuard && !item.grantGuard(this.configService.appSettings.supportedOAuthGrants)) {
          return false;
        }
        if (item.configGuard && !item.configGuard(this.configService.appSettings)) {
          return false;
        }
        return true;
      }),
    );
  }
}
